export default class TableIndexHelper {
  static isFirst(value: number) {
    return value === 0;
  }

  index: number;

  constructor(index: number) {
    this.index = index;
  }

  isCurrent(value: number) {
    return value === this.index + 1;
  }
}

export const selectIndex = (state: number, index: number) =>
  state === null || state !== index + 1 ? index + 1 : null;
